import mastercard from '../assets/mastercard.svg'
import visa from '../assets/visa4.svg'
import elo from '../assets/elo.svg'
import hipercard from '../assets/hipercard.svg'
import americanExpress from '../assets/americanExpress.svg'

export const arranjos = {
    'ACC': 'Amex Cartão de Crédito',
    'AGC': 'Agiplan Cartão de Crédito',
    'AUC': 'Aura Cartão de Crédito',
    'AVC': 'Avista Cartão de Crédito',
    'BCC': 'Banescard Cartão de Crédito',
    'BCD': 'Banescard Cartão de Débito',
    'BNC': 'Banese Crédito',
    'BRC': 'Brasil Card Cartão de Crédito',
    'BRS': 'Banrisul (Compra)',
    'CBC': 'Cabal Crédito',
    'CBD': 'Cabal Débito',
    'CCD': 'Calcard Cartão de Crédito',
    'CSC': 'Credi-Shop Cartão de Crédito',
    'CUP': 'CUP Cartão de Crédito',
    'CZC': 'Credz Cartão de Crédito',
    'DAC': 'Dacasa Cartão de Crédito',
    'DBC': 'Discover Cartão de Crédito',
    'DCC': 'Dinners Cartão de Crédito',
    'ECC': 'Elo Cartão de Crédito',
    'ECD': 'Elo Cartão de Débito',
    'FRC': 'Fortbrasil Cartão de Crédito',
    'GCC': 'Goodcard Crédito',
    'HCC': 'Hipercard Cartão de Crédito',
    'HCD': 'Hipercard Cartão de Débito',
    'JCC': 'JCB Cartão de Crédito',
    'MAC': 'Mais Cartão de Crédito',
    'MCC': 'Mastercard Cartão de Crédito',
    'MCD': 'Mastercard Cartão de Débito',
    'MXC': 'Maxifrota Cartão de Crédito',
    'OCD': 'Ourocard Cartão de Débito',
    'RCC': 'Redesplan Cartão de Crédito',
    'SCC': 'Sorocred Cartão de Crédito',
    'SCD': 'Sorocred Cartão de Débito',
    'SFC': 'Senff Cartão de Crédito',
    'SIC': 'Sicred (Compra)',
    'SPC': 'Sem Parar Cartão de Crédito',
    'TKC': 'Ticketlog Pós Cartão de Crédito',
    'VCC': 'Visa Cartão de Crédito',
    'VCD': 'Visa Cartão de Débito',
    'VDC': 'Verdecard Cartão de Crédito',
}

// export const arranjosPrincipais = {
//     'MCC': 'Mastercard Cartão de Crédito',
//     'ECC': 'Elo Cartão de Crédito',
//     'VCC': 'Visa Cartão de Crédito',
//     'HCC': 'Hipercard Cartão de Crédito',
//     'ACC': 'Amex Cartão de Crédito',
// }

export const arranjosPrincipais = {
    'MCC': 'Mastercard Cartão',
    'ECC': 'Elo Cartão',
    'VCC': 'Visa Cartão',
    'HCC': 'Hipercard Cartão',
    'ACC': 'Amex Cartão',
}


export const arranjoToIcon = {
    'MCC': 'mastercard',
    'ECC': 'elo',
    'VCC': 'visa',
    'HCC': 'hipercard',
    'ACC': 'americanExpress',
}

export function getIcon(produto: string) {
    if (produto === 'MCC') {
        return mastercard
    }

    if (produto === 'VCC') {
        return visa
    }

    if (produto === 'ECC') {
        return elo
    }
    if (produto === 'HCC') {
        return hipercard
    }

    if (produto === 'ACC') {
        return americanExpress
    }

    return ''

}